import { sharedInitialValues } from '../shared/sharedInitialValues';

export const initialValues = (values = {}) => ({
    ctType: null,
    isPregnat: null,
    howManyExaminations: '',
    referralBodyPart: '',
    experiencedPain: '',
    uploadedFile: [],
    ...sharedInitialValues(values),
});
